import './styles/WebSheetTemplateWrapper.scss';

import { DEVICE_TYPES, templates } from '../../constants/websheetsConstants';
import { useClassHelper } from '../../hooks';
import {
  BrandingConfig,
  TemplateType,
  WebsheetTemplateProps,
} from '../../types';

const componentName = 'c-WebSheetTemplateWrapper';

interface Props extends WebsheetTemplateProps {
  onCloseHandler?: () => void;
  templateType?: TemplateType;
  webSheetRefVal?: any;
  styles: BrandingConfig;
  webSheet?: any;
  isPortalTest?: boolean;
  currentPreviewType?: string;
  deviceType?: (typeof DEVICE_TYPES)[keyof typeof DEVICE_TYPES];
}

const WebSheetTemplateWrapper = ({
  templateType,
  webSheetRefVal: templateRef,
  styles,
  webSheet: useCase,
  settings,
  t,
  text,
  isPortalTest = true,
  isPortalPreview = false,
  currentPreviewType = 'a',
  currentLocale,
  services = {},
  deviceSdk,
  state,
  selectedField,
  approveHandler,
  declineHandler,
  fetchDataHandler,
  onCloseHandler,
  portalMessenger,
  deviceType,
}: Props) => {
  const c = useClassHelper(componentName);

  const textFromReference = templateRef
    ? templateRef.current[templateType]
    : {};

  const screen = templates[templateType] || null;
  const TemplateScreen = screen
    ? screen[textFromReference.version || currentPreviewType]
    : null;
  const textTemplate = templateRef ? textFromReference : text;

  return (
    <div className={componentName}>
      <section className={c('__phone')}>
        {isPortalTest && (
          <header className="cancel bg-gray-800">
            <button className={c('__cancel_button')} onClick={onCloseHandler}>
              {t('webSheetPreview.header_cancel')}
            </button>
          </header>
        )}
        {TemplateScreen && (
          <TemplateScreen
            approveHandler={approveHandler}
            declineHandler={declineHandler}
            fetchDataHandler={fetchDataHandler}
            portalMessenger={portalMessenger}
            values={styles}
            text={textTemplate}
            settings={useCase?.settings || settings}
            services={services}
            currentLocale={currentLocale}
            deviceSdk={deviceSdk}
            state={state}
            isPortalTest={isPortalTest}
            isPortalPreview={isPortalPreview}
            selectedField={selectedField}
            deviceType={deviceType}
            t={t}
          />
        )}
      </section>
    </div>
  );
};

export default WebSheetTemplateWrapper;
